module.exports = __webpack_public_path__ + "img/logo.da778d70.svg";